<template>
  <div class="printBox page6 common">
    <div class="bg-t"></div>
    <div class="content">
      <div style="color: #0066CC;">
        <div style="font-size: 32px;margin-bottom: 10px;">六、干预建议</div>
        <div style="font-size: 24px;">(一) 建立心理健康智能筛查体系</div>
      </div>
      <div>
        <div class="title">1、制定监测指标与工具</div>
        <div class="text">
          <p>成立专业团队，结合心理学、教育学、医学等领域专家的意见，制定适用大学生的心理健康监测指标。采购心理健康评估工具，如在线问卷、心理测验等，确保工具的科学性和有效性。定期更新监测指标和工具，以适应不断变化的大学生心理健康需求。</p>
        </div>
      </div>
      <div>
        <div class="title">2、建设分级测评体系</div>
        <div class="text">
          <p>根据学生的年级、专业、性别、生活习惯等因素，设计不同层级的测评方案。 实施分层的测评，确保到每个学生都能接受到适合自己情况的心理健康评估。建立测评结果的数据库，用于分析趋势和制定干预策略。</p>
        </div>
      </div>
      <div>
        <div class="title">3、建立个人心理健康档案</div>
        <div class="text">
          <p>新生入学时，通过初始测评结果建立档案，随后的测评结果定期更新。档案包括学生的基本信息、测评结果、干预措施、变化趋势等。确保档案的隐私性和安全性，遵循相关法律法规。</p>
        </div>
      </div>
      <div>
        <div class="title">4、及时给予测评反馈</div>
        <div class="text">
          <p>在测评结束后，利用智能系统快速分析结果，为各个学生提供个性化反馈报告。 反馈报告包括学生的心理健康状况、建议的改善措施和资源链接。通过线上线下相结合的方式，让学生能够轻松获取和理解反馈信息。</p>
        </div>
      </div>
      <div>
        <div class="title">5、建立预警模型</div>
        <div class="text">
          <p>基于测评的数据，运用数据分析技术构建预警模型，识别潜在的高风险个体。 当系统识别出高风险个体时，自动向相关责任人和心理健康服务人员发送预警信息。完善四级预警网络，确保预警信息能够及时传递到校、院（年级）、班、个人，各个层级。</p>
        </div>
      </div>
      <div>
        <div class="title">6、学校与精神卫生医疗机构联动</div>
        <div class="text">
          <p>建立校医合作机制，定期交流学生心理健康状况和干预经验。邀请精神卫生 医疗机构的专业人员到校开展讲座和咨询服务。在必要时，为学生提供快速转介服务，确保他们能够及时获得专业的精神卫生支持。</p>
        </div>
      </div>
    </div>
    <div class="bg-b"></div>
  </div>
</template>

<script setup>

</script>

<style lang="scss" scoped>
.page6{
  position: relative;
}
.page6 .title{
  font-size: 21px;
  color: #000;
}
.page6 .text{
  font-size: 16px;
  color: #333;
}
.page6 .text p{
  text-indent: 2em;
  line-height: 2;
  margin: 0;
}
.page6 .content{
  padding: 80px;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.page6 .bg-t{
  position: absolute;
  top: 0;
  right: 0;
  width: 231px;
  height: 338px;
  background: url("@/assets/images/report-rt.png") no-repeat;
  background-size: 100% 100%;
}
.page6 .bg-b{
  position: absolute;
  bottom: 0;
  left: 0;
  width: 231px;
  height: 338px;
  background: url("@/assets/images/report-lb.png") no-repeat;
  background-size: 100% 100%;
}
</style>